module.exports = __webpack_public_path__ + "static/media/change-org.4a92a055.svg";